module.exports = __webpack_public_path__ + "static/media/bg_08.d9f12501.png";